export default __webpack_public_path__ + "static/media/photo--lg--food-1.a1c03622.jpg";